import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';

const reviews = [
  {
    name: '张先生',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20portrait%20professional%20headshot%20with%20warm%20smile%2C%20simple%20neutral%20background%2C%20natural%20lighting%2C%20casual%20formal&width=100&height=100&seq=avatar-zhang&orientation=squarish',
    rating: 5,
    date: '2026-07-28',
    content: '真的没有广告，播放速度也很快！之前用的几个网站都是广告弹窗，爱丫爱丫影院完全没有这个问题，画质也很清晰。',
  },
  {
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%20with%20gentle%20smile%2C%20simple%20cream%20background%2C%20soft%20natural%20lighting%2C%20casual%20professional%20headshot&width=100&height=100&seq=avatar-li&orientation=squarish',
    rating: 5,
    date: '2026-07-25',
    content: '资源很丰富，想看的电影和电视剧基本都能找到。更新速度也很快，新剧刚播完就能在这里看了。推荐给身边好多朋友了！',
  },
  {
    name: '王同学',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20portrait%20with%20glasses%20and%20friendly%20smile%2C%20simple%20light%20background%2C%20bright%20natural%20lighting%2C%20casual%20style&width=100&height=100&seq=avatar-wang&orientation=squarish',
    rating: 4,
    date: '2026-07-22',
    content: '大学生一枚，每天晚上都用爱丫爱丫追剧。秒开真的很重要，之前看别的网站等缓冲等得心烦，这里完全不用等，体验太好了。',
  },
  {
    name: '赵女士',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%20elegant%20and%20warm%20smile%2C%20neutral%20beige%20background%2C%20soft%20natural%20studio%20lighting%2C%20friendly%20professional%20headshot&width=100&height=100&seq=avatar-zhao&orientation=squarish',
    rating: 5,
    date: '2026-07-18',
    content: '作为一个妈妈，经常需要给孩子找动画片看。这里的动画资源又多又好，而且没有乱七八糟的弹窗，孩子自己操作也很安全放心。',
  },
  {
    name: '陈先生',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20portrait%20casual%20confident%20smile%2C%20simple%20gray%20background%2C%20natural%20lighting%2C%20professional%20but%20relaxed%20headshot&width=100&height=100&seq=avatar-chen&orientation=squarish',
    rating: 5,
    date: '2026-07-15',
    content: '电影画质真的不错，1080P高清看着很舒服。分类也很清晰，找电影很方便。希望网站越做越好，会一直支持！',
  },
  {
    name: '刘女士',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%20warm%20friendly%20smile%2C%20simple%20pastel%20background%2C%20soft%20natural%20daylight%2C%20casual%20headshot&width=100&height=100&seq=avatar-liu&orientation=squarish',
    rating: 4,
    date: '2026-07-12',
    content: '用了大半年了，播放一直很稳定。特别喜欢晚上窝在沙发里用平板看剧，高清画质大屏看着真过瘾。无广告体验真的棒。',
  },
];

const contactFormUrl = 'https://readdy.ai/api/form/d9obmpgbdkpk99j7gto0';

export default function AboutPage() {

  return (
    <>
      {/* Schema.org - AboutPage */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          name: '关于爱丫爱丫影院',
          description: '爱丫爱丫影院提供高清电影免费在线观看，流畅播放秒开看剧，无广告不缓冲，极速观影体验。了解我们的品牌故事和服务理念。',
          url: 'https://www.aiyaaiya.com/about',
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.aiyaaiya.com/' },
            { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://www.aiyaaiya.com/about' },
          ],
        })}
      </script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero */}
          <section className="pt-24 pb-10 md:pt-28 md:pb-14 bg-gradient-to-b from-background-100 to-background-50">
            <div className="max-w-[1280px] mx-auto px-4 md:px-6 text-center">
              <nav className="flex items-center justify-center gap-2 text-xs text-foreground-400 mb-4" aria-label="面包屑导航">
                <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
                <span>/</span>
                <span className="text-foreground-600">关于我们</span>
              </nav>
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">关于爱丫爱丫影院</h1>
              <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
                致力于为广大影迷提供流畅、高清、无广告的在线观影体验
              </p>
            </div>
          </section>

          {/* Brand Introduction */}
          <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
              <div>
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 mb-5">
                  <i className="ri-movie-2-line text-primary-500 text-xl"></i>
                </div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-4">品牌故事</h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  爱丫爱丫影院创立于2024年，由一个热爱电影的年轻团队打造。我们的初心很简单——让每个人都能轻松享受高品质的观影体验。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  在短视频和碎片化内容泛滥的时代，我们相信一部好电影、一部好剧依然有着无可替代的魅力。爱丫爱丫影院汇聚了海量的高清电影和电视剧资源，涵盖动作、喜剧、爱情、科幻、悬疑、动画等多种类型，满足不同观众的观影需求。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们采用先进的视频加速技术，确保<strong>流畅播放、秒开看剧</strong>。同时坚持<strong>无广告</strong>原则，让用户的观影过程不受任何打扰。极速观影、不卡顿，是我们的核心承诺。
                </p>
              </div>
              <div className="aspect-[4/3] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20movie%20streaming%20team%20collaborating%20in%20creative%20office%20with%20large%20screen%20displaying%20film%20content%2C%20warm%20lighting%2C%20casual%20atmosphere%2C%20creative%20workspace%20with%20film%20posters%20on%20wall&width=800&height=600&seq=about-brand&orientation=landscape"
                  alt="爱丫爱丫影院团队"
                  title="爱丫爱丫影院 - 品牌故事"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </section>

          {/* Features */}
          <section className="bg-background-100/70 py-10 md:py-14">
            <div className="max-w-[1280px] mx-auto px-4 md:px-6">
              <div className="text-center mb-8 md:mb-10">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-2">我们的优势</h2>
                <p className="text-sm text-foreground-500">为什么选择爱丫爱丫影院</p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                {[
                  { icon: 'ri-speed-up-line', title: '秒开看剧', desc: '先进的视频加速技术，点击即播，无需等待缓冲' },
                  { icon: 'ri-advertisement-line', title: '无广告播放', desc: '全程无广告打扰，沉浸式观影体验' },
                  { icon: 'ri-4k-line', title: '高清画质', desc: '1080P高清画质，清晰细腻的视觉享受' },
                  { icon: 'ri-refresh-line', title: '每日更新', desc: '最新电影电视剧每日同步更新，海量资源不断扩充' },
                ].map((feature) => (
                  <div key={feature.title} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60">
                    <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl bg-primary-100 mb-4">
                      <i className={`${feature.icon} text-primary-500 text-lg md:text-xl`}></i>
                    </div>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* User Reviews */}
          <section id="reviews" className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-2">用户口碑</h2>
              <p className="text-sm text-foreground-500">听听我们的用户怎么说</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {reviews.map((review) => (
                <div key={review.name} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                      <img src={review.avatar} alt={review.name} className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-foreground-900">{review.name}</div>
                      <div className="text-xs text-foreground-400">{review.date}</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-0.5 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <div key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className={`text-xs ${i < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}></i>
                      </div>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{review.content}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Contact */}
          <section id="contact" className="bg-background-100/70 py-10 md:py-14">
            <div className="max-w-[1280px] mx-auto px-4 md:px-6">
              <div className="max-w-[600px] mx-auto">
                <div className="text-center mb-8">
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-2">联系我们</h2>
                  <p className="text-sm text-foreground-500">有任何问题或建议，欢迎随时联系我们</p>
                </div>

                <div className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60 mb-6">
                  <div className="space-y-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 flex-shrink-0">
                        <i className="ri-mail-line text-primary-500"></i>
                      </div>
                      <div>
                        <div className="text-xs text-foreground-400">电子邮箱</div>
                        <div className="text-sm font-medium text-foreground-700">contact@aiyaaiya.com</div>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 flex-shrink-0">
                        <i className="ri-customer-service-line text-accent-600"></i>
                      </div>
                      <div>
                        <div className="text-xs text-foreground-400">客服热线</div>
                        <div className="text-sm font-medium text-foreground-700">400-888-电影</div>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-100 flex-shrink-0">
                        <i className="ri-time-line text-secondary-600"></i>
                      </div>
                      <div>
                        <div className="text-xs text-foreground-400">服务时间</div>
                        <div className="text-sm font-medium text-foreground-700">周一至周日 9:00 - 22:00</div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Contact Form */}
                <form
                  id="contact-form"
                  data-readdy-form
                  action={contactFormUrl}
                    method="POST"
                    encType="application/x-www-form-urlencoded"
                    className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60"
                  >
                    <h3 className="text-base font-semibold text-foreground-900 mb-4">发送消息</h3>
                    <div className="space-y-4">
                      <div>
                        <label htmlFor="contact-name" className="block text-xs text-foreground-500 mb-1.5">姓名</label>
                        <input
                          id="contact-name"
                          name="name"
                          type="text"
                          required
                          className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-300 transition-colors"
                          placeholder="请输入您的姓名"
                        />
                      </div>
                      <div>
                        <label htmlFor="contact-email" className="block text-xs text-foreground-500 mb-1.5">邮箱</label>
                        <input
                          id="contact-email"
                          name="email"
                          type="email"
                          required
                          className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-300 transition-colors"
                          placeholder="请输入您的邮箱"
                        />
                      </div>
                      <div>
                        <label htmlFor="contact-message" className="block text-xs text-foreground-500 mb-1.5">留言内容</label>
                        <textarea
                          id="contact-message"
                          name="message"
                          rows={4}
                          maxLength={500}
                          required
                          className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                          placeholder="请输入您的留言内容（最多500字）"
                        ></textarea>
                        <p className="text-[10px] text-foreground-400 mt-1 text-right">最多500个字符</p>
                      </div>

                      {/* Honeypot */}
                      <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="absolute left-[-9999px] opacity-0 h-0 w-0 overflow-hidden pointer-events-none" />

                      <button
                        type="submit"
                        className="w-full py-3 bg-primary-500 text-white rounded-lg text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
                      >
                        发送消息
                      </button>
                    </div>
                </form>
              </div>
            </div>
          </section>
        </main>

        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}